import React from "react";
import PortalModal from "../../Portals";
import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  ContentModalActiveSurvey,
  CloseModalActiveSurvey,
  TextModalActiveSurvey,
  ButtonActiveSurvey,
  ButtonActiveSurveyCancel,
  ContentModal,
  ActionButtons,
  ModalTitle,
} from "./ModalConfirm.styled";

const ModalConfirm = ({
  info,
  infoVar,
  handleConfirm,
  setModalVisibility,
  showCancel = true,
  modalTitle,
  is
}) => {
  return (
    <PortalModal>
      <ContentModal>
        <ContentModalActiveSurvey>
          <CloseModalActiveSurvey>
            {modalTitle && <ModalTitle>{modalTitle}</ModalTitle>}
            <Tooltip title="close">
              <IconButton onClick={() => setModalVisibility()}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </CloseModalActiveSurvey>
          <TextModalActiveSurvey>
            <p>
              {info}
              {infoVar && <strong>{infoVar}</strong>}
            </p>
          </TextModalActiveSurvey>
          <ActionButtons>
            <ButtonActiveSurvey
              showCancel={showCancel}
              onClick={() => {
                handleConfirm();
                setModalVisibility();
              }}
            >
              OK
            </ButtonActiveSurvey>
            {showCancel && (
              <ButtonActiveSurveyCancel onClick={() => setModalVisibility()}>
                Cancel
              </ButtonActiveSurveyCancel>
            )}
          </ActionButtons>
        </ContentModalActiveSurvey>
      </ContentModal>
    </PortalModal>
  );
};

export default ModalConfirm;
